var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDataRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.12977C2 3.40125 3.21565 2 4.71523 2H19.2848C20.7843 2 22 3.40125 22 5.12977C22 6.8583 20.7843 8.25954 19.2848 8.25954H4.71523C3.21565 8.25954 2 6.8583 2 5.12977ZM4.71523 3.67939C4.0203 3.67939 3.45695 4.32875 3.45695 5.12977C3.45695 5.93079 4.0203 6.58015 4.71523 6.58015H19.2848C19.9797 6.58015 20.543 5.93079 20.543 5.12977C20.543 4.32875 19.9797 3.67939 19.2848 3.67939H4.71523Z",
    fill: "#3A3C45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.70991C2 7.98139 3.21565 6.58014 4.71523 6.58014H19.2848C20.7843 6.58014 22 7.98139 22 9.70991C22 11.4384 20.7843 12.8397 19.2848 12.8397H4.71523C3.21565 12.8397 2 11.4384 2 9.70991ZM4.71523 8.25953C4.0203 8.25953 3.45695 8.90889 3.45695 9.70991C3.45695 10.5109 4.0203 11.1603 4.71523 11.1603H19.2848C19.9797 11.1603 20.543 10.5109 20.543 9.70991C20.543 8.90889 19.9797 8.25953 19.2848 8.25953H4.71523Z",
    fill: "#3A3C45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.2901C2 12.5616 3.21565 11.1603 4.71523 11.1603H19.2848C20.7843 11.1603 22 12.5616 22 14.2901C22 16.0186 20.7843 17.4199 19.2848 17.4199H4.71523C3.21565 17.4199 2 16.0186 2 14.2901ZM4.71523 12.8397C4.0203 12.8397 3.45695 13.4891 3.45695 14.2901C3.45695 15.0911 4.0203 15.7405 4.71523 15.7405H19.2848C19.9797 15.7405 20.543 15.0911 20.543 14.2901C20.543 13.4891 19.9797 12.8397 19.2848 12.8397H4.71523Z",
    fill: "#3A3C45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.8702C2 17.1417 3.21565 15.7404 4.71523 15.7404H19.2848C20.7843 15.7404 22 17.1417 22 18.8702C22 20.5987 20.7843 22 19.2848 22H4.71523C3.21565 22 2 20.5987 2 18.8702ZM4.71523 17.4198C4.0203 17.4198 3.45695 18.0692 3.45695 18.8702C3.45695 19.6712 4.0203 20.3206 4.71523 20.3206H19.2848C19.9797 20.3206 20.543 19.6712 20.543 18.8702C20.543 18.0692 19.9797 17.4198 19.2848 17.4198H4.71523Z",
    fill: "#3A3C45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataRound);
export default __webpack_public_path__ + "static/media/ic-data-round.7dd0e6dfea5f1b947c779127c24daafd.svg";
export { ForwardRef as ReactComponent };